import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  palette: {
    action: {
      disabled: 'transparent',
      disabledBackground: 'transparent',
    },
    primary: {
      main: '#9e29cc',
      contrastText: '#ffffff',
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        width: '120px',
      },
    },
  },
  shadows: [
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
  ],
});
